/* SAMPLE INITIALIZATION

var myModalHooks = {
    beforeOpen: function() { return false; },
    afterOpen: function() { return false; },
    onContinue: function() { return false; },
    beforeClose: function() { return false; },
    afterClose: function() { return false; },
    setSize: function() { return false; },
    onInit: function() { return false; }
}

var modalEl = document.querySelector('.modal-target');
var myModal = modal.initModal(modalEl, myModalHooks);

var myModalTriggers = document.querySelectorAll('.modal-trigger');

PL_utils.eleOnClick(function() {
    myModal.showModal();
}, myModalTriggers);

*/

/* eslint-disable */
import PL_utils from './pl-utils.js';

var aria = aria || {};

aria.Modal = aria.Modal || {};

aria.Modal.getAllChildren = function (target) {
  var processedChildren = [];
  var unprocessedChildren = [].slice.call(target.children);

  while (unprocessedChildren.length > 0) {
    var processing = unprocessedChildren.shift();
    unprocessedChildren = [].slice.call(processing.childNodes).concat(unprocessedChildren)
    processedChildren.push(processing);
  }

  return processedChildren;
}

aria.Modal.getAllFocusables = function (target) {
  var modalNodes = aria.Modal.getAllChildren(target);
  var focusables = [].filter.call(modalNodes, function (node) {
    return aria.Modal.isFocusable(node);
  });
  return focusables;
}

aria.Modal.isFocusable = function (element) {
  if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel != 'ignore';
    case 'INPUT':
      return element.type != 'hidden' && element.type != 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
}

var modal = (function () {
  if (typeof PL_utils === "undefined") {
    console.log('fad.modal.js required pl-utils.js as a dependency.');
    return;
  }

  var PL = PL_utils;
  var bodyTarget = document.querySelector('body');

  var showModal = function (target, hooks) {
    // preShowModalHooks
    if (hooks && hooks.beforeOpen) {
      hooks.beforeOpen(target);
    }

    // Add Backdrop
    if (!anyModalActive()) {
      addBackdrop();
    }

    // Set Modal Size
    if (hooks && hooks.setSize) {
      hooks.setSize(target);
    }

    // Show Modal
    PL.addClass("modal--active", target);

    // Disable background body on scroll
    PL.addClass("modal--open", bodyTarget);

    // preShowModalHooks
    if (hooks && hooks.afterOpen) {
      hooks.afterOpen(target);
    }

    // Focus first element when opening modal.
    var focusTargets = aria.Modal.getAllFocusables(target);
    var firstFocusable = focusTargets[0];

    // Set open
    //firstFocusable.focus();
  }

  var hideModal = function (target, hooks) {
    if (hooks && hooks.beforeClose) {
      hooks.beforeClose(target);
    }

    // Hide Modal
    PL.removeClass("modal--active", target);

    // Remove no scroll class from body
    PL.removeClass("modal--open", bodyTarget);

    // Clean up Modal Backdrop
    if (!anyModalActive()) {
      removeBackdrop();
    }

    if (hooks && hooks.afterClose) {
      hooks.afterClose(target);
    }
  }

  var anyModalActive = function () {
    return document.querySelectorAll('.modal--active').length > 0;
  }

  var removeBackdrop = function () {
    var backdrop = document.querySelector('.backdrop');
    PL.removeClass("modal__backdrop--active", backdrop);
  }

  var addBackdrop = function () {
    var backdrop = document.querySelector('.backdrop');
    PL.addClass("modal__backdrop--active", backdrop);
  }

  var bindClose = function (target, hooks) {
    var closeBtn = target.querySelector('.modal__close');
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      hideModal(target, hooks);
    });
    closeBtn.addEventListener('keydown', function (e) {
      // Close modal if they press enter.
      if (e.which === 13) {
        hideModal(target, hooks);
        e.preventDefault();
      }
    })
  }

  var bindContinue = function (target, hooks) {
    var contBtn = target.querySelector('.modal__continue');
    var errorMessage = target.querySelector('.continued-required');
    var modalContent = target.querySelector('.modal__body');


    if (contBtn) {
      contBtn.addEventListener('click', function (e) {
        var fatp_checked = document.getElementById('fatp-continue').checked;

        if (!fatp_checked && errorMessage) {
          PL.removeClass("hidden", errorMessage);
          modalContent.scrollTo(0, target.querySelector('.modal__body--scrollable').scrollHeight);
          errorMessage.focus();
          e.preventDefault();
          return;
        }
        if (hooks && hooks.onContinue) {
          if (fatp_checked) {
            window.eventsManager.emit("continueModal", { type: "disclaimer", params: "" });
          }
         hooks.onContinue(e, target);
         //hideModal(target, hooks);
        }
      });
    }
  }

  var bindCancel = function (target, hooks) {
    var cancelBtn = target.querySelector('.modal__cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        hideModal(target, hooks);
      });
    }
  }

  var bindBackdrop = function (target, hooks) {
    var modalBackdrop = document.querySelector('.backdrop');
    modalBackdrop.addEventListener('click', function (e) {
      e.preventDefault();
      hideModal(target, hooks);
    });
  }

  var bindAccessibility = function (target, hooks) {
    var focusTargets = aria.Modal.getAllFocusables(target);
    var firstFocusable = focusTargets[0];
    var lastFocusable = focusTargets[focusTargets.length - 1];

    // When final element tabbed, loop to first element
    lastFocusable.addEventListener('keydown', function (e) {
      if (!PL.hasClass('modal--active', target)) return;
      if (!e.shiftKey && e.which == 9) {
        e.preventDefault();
        firstFocusable.focus();
      }
    });

    // When First element shift-tabbed, loop to last element
    firstFocusable.addEventListener('keydown', function (e) {
      if (!PL.hasClass('modal--active', target)) return;
      if (e.shiftKey && e.which == 9) {
        e.preventDefault();
        lastFocusable.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!PL.hasClass('modal--active', target)) return;
      // On ESC, close modal.
      if (e.which === 27) {
        hideModal(target, hooks);
      }
    })
  }

  var bindEvents = function (target, hooks, opts) {
    bindClose(target, hooks);
    bindContinue(target, hooks);
    bindCancel(target, hooks);
    bindAccessibility(target, hooks);
    if (!opts || opts.enableBackdropClose != false) {
      bindBackdrop(target, hooks);
    }
  }


  var initModal = function (target, hooks, opts) {
    
    // Validate we received a legitiment target
    var validTarget = PL.hasClass("modal", target);
    if (!validTarget) {
      console.log('Must init Modal with class "modal". Exiting initModal with no actions taken.');
      return;
    }

    var showTargetModal = PL.partial(showModal, target, hooks);
    var hideTargetModal = PL.partial(hideModal, target, hooks);

    bindEvents(target, hooks, opts);

    if (hooks && hooks.onInit) {
      hooks.onInit(target);
    }

    window.addEventListener('resize', function () {
      // Set Modal Size
      if (hooks && hooks.setSize) {
        hooks.setSize(target);
      }
    })

    var modalInterface = {
      showModal: showTargetModal,
      hideModal: hideTargetModal
    }

    return modalInterface;
  }

  return {
    initModal: initModal
  };
})();

export default modal;
